import { render, staticRenderFns } from "./ChangeClient.vue?vue&type=template&id=038c7053&"
import script from "./ChangeClient.vue?vue&type=script&lang=js&"
export * from "./ChangeClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports